import { useMutation } from '@apollo/client/react';
import {
  STAFF_ACCOUNTS_FORCE_REFRESH,
  STAFF_ACCOUNTS_CHANGE_COMPANY_OWNER,
  STAFF_ACCOUNTS_CHANGE_TEAM_OWNER,
  STAFF_ACCOUNTS_RESET_ENGAGE_USAGE,
  STAFF_ACCOUNTS_RESET_CARD_COUNTER,
  STAFF_ACCOUNTS_NEW_HIRE,
} from '@staff-app/graphql-client';
import type { SalesActionResult } from './useSalesConsole';

type ChangeOwnerVars = { currentOwnerEmail: string; newOwnerEmail: string };
type StripeVars = { stripeId: string };
type NewHireVars = { stripeId: string; trialEndDate: string };

export function useChangeCompanyOwner() {
  return useMutation<{ staffAccountsChangeCompanyOwner: SalesActionResult }, ChangeOwnerVars>(
    STAFF_ACCOUNTS_CHANGE_COMPANY_OWNER,
  );
}

export function useChangeTeamOwner() {
  return useMutation<{ staffAccountsChangeTeamOwner: SalesActionResult }, ChangeOwnerVars>(
    STAFF_ACCOUNTS_CHANGE_TEAM_OWNER,
  );
}

export function useForceRefresh() {
  return useMutation<{ staffAccountsForceRefresh: SalesActionResult }, StripeVars>(
    STAFF_ACCOUNTS_FORCE_REFRESH,
  );
}

export function useResetEngageUsage() {
  return useMutation<{ staffAccountsResetEngageUsage: SalesActionResult }, StripeVars>(
    STAFF_ACCOUNTS_RESET_ENGAGE_USAGE,
  );
}

export function useResetCardCounter() {
  return useMutation<{ staffAccountsResetCardCounter: SalesActionResult }, StripeVars>(
    STAFF_ACCOUNTS_RESET_CARD_COUNTER,
  );
}

export function useNewHireEnableAll() {
  return useMutation<{ staffAccountsNewHireEnableAll: SalesActionResult }, NewHireVars>(
    STAFF_ACCOUNTS_NEW_HIRE,
  );
}
